import { ProjectAPI } from 'api/project';
import { getPhaseProjectId, phaseCollection } from './phase-collection';
/**
 * Single writer for phase data arriving embedded in another entity's
 * response (project detail, plan board) or from a dedicated phase-list
 * fetch. Stamps `projectId` when the caller already knows it and the bean
 * omitted it (see the canonical-shape hazard in `phase-collection.ts`).
 *
 * `merge` mode (default): a board/dropdown-list fetch is lower-fidelity than
 * project detail and must not drop richer fields (`fields[]`,
 * `progressStatus`) off a detail-fetched bean — same fidelity hazard as
 * `collections/project/fetchers.ts`. Detail callers pass `'replace'`.
 */ export const mergePhasesIntoCollection = (phases, projectId, mode = 'merge')=>{
    if (phases == null || phases.length === 0) {
        return;
    }
    const stamped = phases.map((phase)=>getPhaseProjectId(phase) != null || projectId == null ? phase : {
            ...phase,
            projectId
        });
    phaseCollection.push(stamped, {
        source: 'fetch',
        mode
    });
};
/** GET a project's phase list (dropdown-option fidelity) → mirror, return raw. */ export const fetchPhasesForProject = async (projectId)=>{
    const result = await ProjectAPI.getPhasesForAProject(projectId);
    mergePhasesIntoCollection(result, projectId);
    return result;
};
/**
 * GET the paginated/searchable cross-project current-phase list → mirror,
 * return raw. No single `projectId` here (cross-project list) — every row
 * must already carry its own via `phase.project`/`phase.projectId`, so this
 * never stamps.
 */ export const fetchCurrentPhases = async (...args)=>{
    const result = await ProjectAPI.getAllProjectCurrentPhasesV2(...args);
    mergePhasesIntoCollection(result.data, undefined);
    return result;
};
/**
 * GET the non-paginated cross-project current-phase list (the older sibling
 * of `fetchCurrentPhases` — still live, `custom-reports/tabular-report/table.tsx`)
 * → mirror, return raw.
 */ export const fetchAllCurrentPhases = async ()=>{
    const result = await ProjectAPI.getAllProjectCurrentPhases();
    mergePhasesIntoCollection(result, undefined);
    return result;
};
